import { QueryTab } from './queryTab';

export const TestData = {
  QueryTab,
};
